import DismissRegular from 'mini-fluent-svg-icons/lib/icons/DismissRegular';
import React from 'react';
import strings from 'owa-strings/owa-mini-common-strings';
import { Button, ButtonType } from 'mini-button';
import { FluentSvgIcon } from 'mini-fluent-svg-icons/lib/components/FluentSvgIcon';
import { logUsage } from 'owa-analytics';
import { Modal } from 'mini-modal';
import { purgeModalDiv } from 'mini-modal/lib/utils/modalDivUtils';
import { tenantPreventionOutlookExpansion } from 'window-utils/lib/getOpenInNewWindowIcon';
import { toggleModalViewState } from './mutators/changeIsShown';

const styles = require('./Modal.scss');

/**
 * Component which renders the jsx element passed as props in the bottom sheet
 */
export const ComposePreventionModal = (props: any) => {
    const { type } = props;
    const ModalDismiss = ev => {
        toggleModalViewState();
        ev.stopPropagation();
        purgeModalDiv();
        logUsage('composeModalDismiss', {}, { isCore: true });
    };

    return (
        <Modal className={styles.modalPosition}>
            <div className={styles.modalContainerStyle}>
                <div className={styles.parentDivStyle}>
                    <div className={styles.containerStyle}>
                        <p className={styles.headingTextStyles}>
                            {strings.composeActionRestrictedTitle}
                        </p>
                        <div className={styles.closeIcon}>
                            <FluentSvgIcon
                                icon={DismissRegular}
                                onClick={ev => {
                                    ModalDismiss(ev);
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className={styles.divStyle}>
                    <p className={styles.paragraphStyle}>{strings.composePreventionText}</p>
                </div>
                <div className={styles.primaryButtonContainer}>
                    <Button
                        text={strings.searchInfrequentUsersAllModulesPrimaryActionButton}
                        type={ButtonType.InlinePrimary}
                        ariaLabel={strings.searchInfrequentUsersAllModulesPrimaryActionButton}
                        className={styles.primaryButton}
                        hasPopup={false}
                        onClick={ev => {
                            ModalDismiss(ev);
                        }}
                    />
                </div>
                <div className={styles.secondaryButtonContainer}>
                    <Button
                        text={strings.openOutlookButton}
                        className={styles.secondaryButton}
                        type={ButtonType.Default}
                        ariaLabel={strings.openOutlookButton}
                        hasPopup={false}
                        onClick={() => {
                            tenantPreventionOutlookExpansion(type);
                            toggleModalViewState();
                            purgeModalDiv();
                            logUsage('openBigOWAViaModal', {}, { isCore: true });
                        }}
                    />
                </div>
            </div>
        </Modal>
    );
};
